var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDropdown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 4 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dropdown_svg__clip0)",
    fill: "#D4D3D8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8a2 2 0 104 0 2 2 0 00-4 0zM0 2a2 2 0 104 0 2 2 0 00-4 0zM0 14a2 2 0 104 0 2 2 0 00-4 0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dropdown_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(90 2 2)",
    d: "M0 0h16v4H0z"
  })))));
}

export default SvgDropdown;